// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.arrr-agency {
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: #1F106D;
  font-weight: 500;
  margin: 1.5rem 0;
  font-family: "Inter", sans-serif;
  transition-duration: 250ms;
}
@media all and (hover) {
  .arrr-agency:hover {
    filter: opacity(0.5);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ArrrAgency/ArrrAgency.scss"],"names":[],"mappings":"AAEA;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gCAAA;EACA,0BAAA;AADF;AAGE;EAEE;IACE,oBAAA;EAFJ;AACF","sourcesContent":["@import \"src/styles/variables\";\n\n.arrr-agency {\n  z-index: 3;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  color: $main-dark-blue;\n  font-weight: 500;\n  margin: 1.5rem 0;\n  font-family: \"Inter\", sans-serif;\n  transition-duration: 250ms;\n\n  @media all and (hover) {\n\n    &:hover {\n      filter: opacity(0.5);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
